<app-navbar *ngIf="showHeader"></app-navbar>
<app-driver-nav-bar *ngIf="showDriverHeader"></app-driver-nav-bar>
<ngx-spinner type="ball-spin-clockwise"></ngx-spinner>
<router-outlet></router-outlet>